import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../../core/auth/auth.service';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './page-not-found.component.html',
  styleUrl: '../system-page.shared.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  readonly auth = inject(AuthService);
  private readonly location = inject(Location);
  readonly destination = this.auth.isAuthenticated() ? this.auth.homeRoute() : '/auth/home';
  goBack(): void { this.location.back(); }
}
